import { apiSlice } from "./apiSlice";

export const productApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ["PRODUCT"] })
  .injectEndpoints({
    keepUnusedDataFor: 1,
    endpoints: (builder) => ({
      getProducts: builder.query({
        query: (params) => {
          return {
            url: '/product',
            method: "GET",
            params: params,
          };
        },
        providesTags: ["PRODUCT"],
        transformResponse: (response) => response?.body,
        transformErrorResponse: (response, meta, arg) =>
          response?.data?.message ?? "Something went wrong please try again",
      }),
      createProducts: builder.mutation({
        query: (body) => ({
          url: `/product`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["PRODUCT"],
        transformResponse: (response, meta, arg) => {
          console.log("Create response:", response);
          return response?.body ?? response;
        },

        transformErrorResponse: (response, meta, arg) =>
          response?.data?.message ?? "Something went wrong please try again",
      }),

      updateProducts: builder.mutation({
        query: ({ payload, id }) => ({
          url: `/product/${id}`,
          method: "PUT",
          body: { ...payload },
        }),
        invalidatesTags: ["PRODUCT"],
        transformResponse: (response, meta, arg) => {
          console.log("Update response:", response);
          return response?.body ?? response;
        },

        transformErrorResponse: (response, meta, arg) =>
          response?.data?.message ?? "Something went wrong please try again",
      }),

      deleteProducts: builder.mutation({
        query: (id) => ({
          url: `/product/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["PRODUCT"],

        transformErrorResponse: (response, meta, arg) =>
          response?.data?.message ?? "Something went wrong please try again",
      }),
    }),
  });

export const {
  useGetProductsQuery,
  useCreateProductsMutation,
  useUpdateProductsMutation,
  useDeleteProductsMutation
} = productApi;
